import { render, staticRenderFns } from "./ConnectSlack.vue?vue&type=template&id=023f82aa&scoped=true&"
import script from "./ConnectSlack.vue?vue&type=script&lang=js&"
export * from "./ConnectSlack.vue?vue&type=script&lang=js&"
import style0 from "./ConnectSlack.vue?vue&type=style&index=0&id=023f82aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f82aa",
  null
  
)

export default component.exports